import React from "react";
import { GlobalOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./UserInfo.css"

function UserInfo() {
  const navigate = useNavigate();

  return (
    <div className="user-container">
      <GlobalOutlined />
      <div className="userInfo">
        <span className="signin-user" onClick={() => navigate("/signin")}>
          Sign In
        </span>
        <span className="create-user" onClick={() => navigate("/signUp")}>
          Join For Free
        </span>
      </div>
    </div>
  );
}

export default UserInfo;